import { SvgIcon } from '@mui/material';
import React from 'react';

const OrderValidatedIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      width="35"
      height="31"
      viewBox="0 0 35 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.2822 3.07308L23.0967 0.238145C22.8675 0.0826671 22.5982 0 22.3229 0H5.58072C5.30539 0 5.0361 0.0826671 4.80688 0.238145L0.621345 3.07308C0.232984 3.33575 0 3.77849 0 4.2524V26.9319C0 27.7148 0.624561 28.3493 1.39518 28.3493H26.5084C27.279 28.3493 27.9036 27.7148 27.9036 26.9319V4.2524C27.9036 3.77849 27.6706 3.33575 27.2822 3.07308ZM16.7421 1.41747H22.3229L25.462 3.54367H16.7421V1.41747ZM12.5566 1.41747H15.347V3.54367H12.5566V1.41747ZM12.5566 4.96113H15.347V12.7572H12.5566V4.96113ZM5.58072 1.41747H11.1614V3.54367H2.44156L5.58072 1.41747ZM26.5084 26.9319H1.39518V4.96113H11.1614V14.1747H16.7421V4.96113H26.5084V26.9319Z"
        fill="currentColor"
      />
      <path
        d="M31.36 14.64C29.68 12.96 27.4 12 25 12C22.6 12 20.32 12.96 18.64 14.64C16.96 16.32 16 18.6 16 21C16 23.4 16.96 25.68 18.64 27.36C20.32 29.04 22.6 30 25 30C27.4 30 29.68 29.04 31.36 27.36C33.04 25.68 34 23.4 34 21C34 18.6 33.04 16.32 31.36 14.64Z"
        fill="#037836"
      />
      <path
        d="M21 20.9447L24.0369 24L30 18"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default OrderValidatedIcon;
